































































import { CartItem } from '@/models/cart/cart-item'
import { AppliedBundleDiscount, BundleDiscount } from '@/services/api/bundle-discount'
import { formatPrice } from '@/util/format'
import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

interface DiscountGroup {
  discountId: string
  discountTitle: string
  discountAmount: number
  appliedItems: CartItem[]
}

@Component
export default class BundleDiscountGroupList extends Vue {
  @Prop({ required: true })
  readonly cartItems: CartItem[]

  @Prop({ required: true })
  readonly appliedBundleDiscountList: AppliedBundleDiscount[]

  @Prop({ required: true })
  readonly bundleDiscounts: BundleDiscount[]

  readonly formatPrice = formatPrice

  imageClass(group: DiscountGroup, index: number): string {
    // tslint:disable-next-line:no-magic-numbers
    return `image image-${index + 1}of${Math.min(group.appliedItems.length, 3)}`
  }

  get bundleDiscountGroups(): DiscountGroup[] {
    return _.map(
      _.groupBy(this.appliedBundleDiscountList, list => list.bundle_discount_id),
      (appliedBundleDiscounts: AppliedBundleDiscount[]) => {
        const representative = appliedBundleDiscounts[0]
        const discountAppliedTo: any = representative.applied_to

        return {
          discountId: representative.bundle_discount_id,
          discountTitle: this.getTitle(representative.bundle_discount_id),
          discountAmount: _.sumBy(appliedBundleDiscounts, d => d.discount_amount),
          appliedItems: this.cartItems.filter(
            cartItem => discountAppliedTo.some(applied => applied.sku_id === cartItem.skuId)
          ),
        }
      }
    )
  }

  private getTitle(bundleId: string): string {
    const found = this.bundleDiscounts.find(b => b.id === bundleId)

    return found ? found.title : ''
  }
}
